<template>
  <article class="grid lg:grid-cols-3 grid-flow-row lg:grid-flow-col auto-cols-fr gap-5 lg:gap-0">
    <div class="grid custom-grid lg:grid-flow-col lg:auto-rows-min lg:auto-cols-auto gap-x-5 gap-y-4 lg:col-span-2 items-center lg:items-start">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-14 h-14 bg-primary/90 hover:bg-primary transition-colors duration-150 rounded-full p-4 text-secondary-light cursor-pointer select-none lg:row-span-2"
        @click="isPlaying = !isPlaying"
      >
        <path
          v-if="isPlaying"
          fill-rule="evenodd"
          d="M6.75 5.25a.75.75 0 01.75-.75H9a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H7.5a.75.75 0 01-.75-.75V5.25zm7.5 0A.75.75 0 0115 4.5h1.5a.75.75 0 01.75.75v13.5a.75.75 0 01-.75.75H15a.75.75 0 01-.75-.75V5.25z"
          clip-rule="evenodd"
        />
        <path
          v-else
          fill-rule="evenodd"
          d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
          clip-rule="evenodd"
        />
      </svg>
      <Heading :size="3" :text="episode.title" :heading-class="`text-xl lg:text-2xl`" class="lg:mt-2" />
      <p class="text-grey-light text-sm lg:text-base leading-7 col-span-2 lg:col-span-1">
        {{ episode.description }}
      </p>
    </div>
    <div v-if="podcast.spotifyUrl || podcast.appleUrl || podcast.googleUrl" class="grid lg:grid-rows-2 gap-y-4">
      <div class="flex items-center lg:justify-end gap-5 lg:gap-7 xl:gap-10">
        <p class="text-grey-light text-sm lg:text-base">Počúvaj&nbsp;na:</p>
        <figure class="grid grid-flow-col auto-cols-auto gap-4 xl:gap-6">
          <NuxtLink
            v-if="podcast.spotifyUrl"
            :to="podcast.spotifyUrl"
            target="_blank"
            class="inline-flex items-center"
            aria-label="Počúvajte na Spotify"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="w-12 h-12 lg:w-14 lg:h-14 text-primary/90 hover:text-[#1ed760] transition-colors duration-150"
            >
              <path
                d="M17.9,10.9C14.7,9 9.35,8.8 6.3,9.75C5.8,9.9 5.3,9.6 5.15,9.15C5,8.65 5.3,8.15 5.75,8C9.3,6.95 15.15,7.15 18.85,9.35C19.3,9.6 19.45,10.2 19.2,10.65C18.95,11 18.35,11.15 17.9,10.9M17.8,13.7C17.55,14.05 17.1,14.2 16.75,13.95C14.05,12.3 9.95,11.8 6.8,12.8C6.4,12.9 5.95,12.7 5.85,12.3C5.75,11.9 5.95,11.45 6.35,11.35C10,10.25 14.5,10.8 17.6,12.7C17.9,12.85 18.05,13.35 17.8,13.7M16.6,16.45C16.4,16.75 16.05,16.85 15.75,16.65C13.4,15.2 10.45,14.9 6.95,15.7C6.6,15.8 6.3,15.55 6.2,15.25C6.1,14.9 6.35,14.6 6.65,14.5C10.45,13.65 13.75,14 16.35,15.6C16.7,15.75 16.75,16.15 16.6,16.45M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                fill="currentColor"
              />
            </svg>
          </NuxtLink>
          <NuxtLink
            v-if="podcast.appleUrl"
            :to="podcast.appleUrl"
            target="_blank"
            class="inline-flex items-center"
            aria-label="Počúvajte na Apple Podcasts"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="w-12 h-12 lg:w-14 lg:h-14 text-primary/90 hover:text-[#9c5af2] transition-colors duration-150"
            >
              <path fill="currentColor" d="M9.5 15.5c0 -1.2 1 -2 2.5 -2s2.5 0.8 2.5 2C14.5 18 14 23 12 23s-2.5 -5 -2.5 -7.5Z" stroke-width="1"></path>
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M3.25 11a8.75 8.75 0 1 1 12.513 7.902 17.468 17.468 0 0 1 -0.335 1.76c3.975 -1.41 6.822 -5.203 6.822 -9.662C22.25 5.34 17.66 0.75 12 0.75S1.75 5.34 1.75 11c0 4.459 2.847 8.253 6.822 9.663l-0.03 -0.125a17.481 17.481 0 0 1 -0.305 -1.636A8.75 8.75 0 0 1 3.25 11Z"
                clip-rule="evenodd"
                stroke-width="1"
              ></path>
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M6.75 11a5.25 5.25 0 1 1 9.119 3.549c0.086 0.301 0.131 0.62 0.131 0.951 0 0.288 -0.006 0.609 -0.02 0.953a6.75 6.75 0 1 0 -7.96 0c-0.014 -0.344 -0.02 -0.665 -0.02 -0.953 0 -0.331 0.045 -0.65 0.131 -0.951A5.231 5.231 0 0 1 6.75 11Z"
                clip-rule="evenodd"
                stroke-width="1"
              ></path>
              <path fill="currentColor" d="M9.75 10.25a2.25 2.25 0 1 0 4.5 0 2.25 2.25 0 1 0 -4.5 0" stroke-width="1"></path>
            </svg>
          </NuxtLink>
          <NuxtLink
            v-if="podcast.googleUrl"
            :to="podcast.googleUrl"
            target="_blank"
            class="inline-flex items-center"
            aria-label="Počúvajte na YouTube Music"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              class="w-12 h-12 lg:w-14 lg:h-14 text-primary/90 hover:text-[#f03] transition-colors duration-150"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M23 12c0 6.075 -4.925 11 -11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11ZM12 7a5 5 0 1 0 0 10 5 5 0 0 0 0 -10Zm-6 5a6 6 0 1 1 12 0 6 6 0 0 1 -12 0Zm9 0 -5 -3v6l5 -3Z"
                clip-rule="evenodd"
                stroke-width="1"
              ></path>
            </svg>
          </NuxtLink>
        </figure>
      </div>
    </div>
  </article>
</template>
<script setup lang="ts">
const currentPodcastPlaying = useCurrentPodcastPlaying()
const props = defineProps({
  podcast: {
    type: Object,
    required: true,
  },
  episode: {
    type: Object,
    required: true,
  },
})

const audio = ref<HTMLAudioElement | null>(null)
const isPlaying = ref(false)

watch(isPlaying, (value) => {
  if (value) {
    if (currentPodcastPlaying.value) {
      currentPodcastPlaying.value?.pause()
      currentPodcastPlaying.value = ''
    }
    audio.value?.play()
    currentPodcastPlaying.value = audio.value
  } else {
    if (currentPodcastPlaying.value && !audio.value?.paused) {
      audio.value?.pause()
      currentPodcastPlaying.value = ''
    }
  }
})

watch(currentPodcastPlaying, (value, oldValue) => {
  if (oldValue === audio.value) {
    isPlaying.value = false
  }
})

watch(
  () => audio.value?.ended,
  (value) => {
    if (value) {
      currentPodcastPlaying.value = ''
      isPlaying.value = false
    }
  },
)

onMounted(() => {
  audio.value = new Audio(props.episode.audioUrl)
})
</script>

<style scoped>
@reference "~/assets/css/main.css";

.custom-grid {
  grid-template-columns: min-content 1fr;
}

@variant lg {
  .custom-grid {
    @apply grid-cols-none;
  }
}
</style>
